jQuery(document).ready(function($) {
	var map = $('#mapplic'),
		self = map.data('mapplic'),
		mod = null;

	var initialize = function() {
		mod = new MapplicMod().init(map);
	}

	if (self) initialize();
	else {
		map.on('mapready', function(e, s) {
			self = s;
			initialize();
		});
	}

	function MapplicMod() {
		this.init = function() {
			var s = this;
			$('.mapplic-list-location').hover(
				function(){ $('.mapplic-layer .mapplic-pin[data-location="' + $(this).data('location') + '"]', self.el).addClass('mapplic-hover') },
				function(){ $('.mapplic-layer .mapplic-pin[data-location="' + $(this).data('location') + '"]', self.el).removeClass('mapplic-hover') }
			);
			
			$('.mapplic-list-location', self.el).each(function() {
				var loc = self.l[$(this).data('location')];
				$('.mapplic-thumbnail-placeholder', $(this)).text(loc.label).css('background-color', loc.fill);
			});
		}
	
	}

});